import { lazy } from 'react'

export const Home = lazy(
  () => import(/* webpackChunkName: "soc" */ './Home/Home')
)

export const Contract = lazy(
  () => import(/* webpackChunkName: "soc" */ './Contract/Contract')
)

export const Incident = lazy(
  () => import(/* webpackChunkName: "soc" */ './Incident/Incident')
)
